module.exports = require("mdi-material-ui/PhoneHangup");